import { render } from "./MySajuCreatePage.vue?vue&type=template&id=09e7503e&scoped=true"
import script from "./MySajuCreatePage.vue?vue&type=script&lang=js"
export * from "./MySajuCreatePage.vue?vue&type=script&lang=js"

import "./MySajuCreatePage.vue?vue&type=style&index=0&id=09e7503e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e7503e"]])

export default __exports__